import React from 'react'

import classNames from 'classnames'

import IconButton from 'components/Utils/IconButton'
import { CaretNavigationRightIcon } from 'components/Utils/Icons'

export type ExpandControlsProps = {
  id: string
  isExpanded: boolean
  onToggleExpand: (id: string) => void
}

export const ExpandControls = ({
  id,
  isExpanded,
  onToggleExpand,
}: ExpandControlsProps) => {
  const onExpandClick = React.useCallback(
    event => {
      event.preventDefault()
      event.stopPropagation()
      onToggleExpand(id)
    },
    [onToggleExpand, id]
  )

  return (
    <IconButton
      colorScheme="lightGrayOnGray"
      boxSize="smaller"
      onClick={onExpandClick}
    >
      <CaretNavigationRightIcon
        className={classNames('transition', { 'rotate-clockwise': isExpanded })}
        size={16}
      />
    </IconButton>
  )
}
